import { isNone } from '@ember/utils';
import Transform from '@ember-data/serializer/transform';

export default class ImmutableTransform<T> extends Transform {
  deserialize(serialized: T | null | undefined): Readonly<T> | null {
    return isNone(serialized) ? null : Object.freeze(serialized);
  }

  serialize(deserialized: T | null): T | null {
    return isNone(deserialized) ? null : deserialized;
  }
}
